import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import MarkerMaps from './MarkerMaps';
import MapLegendKbdi from './MapLegendKbdi';
import KbdiTable from './KbdiTable';
import RegionHeader from './RegionHeader';
import Error from './Error';
import ColorsContext from './ColorsContext';
import { getDefaultDate, setLongmonyr } from './routines';

function KbdiRegion(props) {
	const monyr = props.date ? props.date : getDefaultDate();
	const areaType = props.areaType;
	const [ markers, setMarkers ] = useState(null);
	const [ regionData, setRegionData ] = useState(null);
	const [ regionError, setRegionError ] = useState(false);
	const [ regionColors, setRegionColors ] = useState([]);
	const [ datestr, setDatestr ] = useState();
	const { levelColors, kbdiColors } = useContext(ColorsContext);

	const selectedState = "ma"
	const ptDataFileNameBase = areaType === "region" ? "station_kbdi_" : `station_${areaType}_kbdi_`;
	const ptDataFileName = (props.match ? ".." : ".") + "/data/" + ptDataFileNameBase + monyr + ".json";
	const rgDataFileNameBase = areaType === "region" ? "regional_kbdi_" : `${areaType}_kbdi_`;
    const rgDataFileName = (props.match ? ".." : ".") + "/data/" + rgDataFileNameBase + monyr + ".json"
	
	let longmonyr = monyr !== 'daily' ? setLongmonyr(monyr) : null;

	// display KBDI between Apr and Nov
	var mon;
	if (monyr !== 'daily') {
		mon = parseInt(monyr.split("-")[1]);
	} else {
		const today = new Date();
		mon = today.getMonth() + 1;
	}
  	const kbdiOn = mon >= 4 && mon <= 11;

	const geodata = require('./geo/fireControlDistricts_geo.json');
	const other_geodata = require(areaType === 'basin' ? './geo/majorBasins_geo.json' : './geo/MAcounties_geo.json');

	const buttonValue = monyr === 'daily' ? 'kbdidlystation' : (monyr.length === 7 ? (areaType === 'region' ? "kbdistation" : `kbdi${areaType}station`) : (areaType === 'region' ? "kbdiwkstation" : `kbdiwk${areaType}station`));
	const addtext = monyr.length === 10 
		? "These data are updated weekly. The values reflect the measurements taken on the date indicated on the map. Data may be provisional."
		: "Data may be provisional.";

	const getPointData = () => {
		let allmarkers = [];
		axios.get(ptDataFileName)
		.then(results => {
			Object.keys(results.data.data).forEach(region => {
				Object.keys(results.data.data[region]).forEach(sky => {
					const stn = results.data.data[region][sky]
					const val = stn.kbdi
					let fcolor = 5
					kbdiColors.some((e, i) => {
						fcolor = e.color
						return val >= e.range[0] && val < e.range[1]
					})
					if (stn.position[0] !== null && stn.position[1] !== null) {
						allmarkers.push({
							position: stn.position, 
							fillColor: fcolor, 
							data: [stn.name,"KBDI: " + val],
						});
					}
				});
			});
			setMarkers(allmarkers);
		})
		.catch(err => {
			console.log("Point Data Error: " + err);
			setRegionError(true);
		});
	}

	const getRegionData = () => {
		axios.get(rgDataFileName)
		.then(results => {
			setRegionData(results.data.data);
			let allRegions = [];
			Object.keys(results.data.data).forEach(region => {
				const zone = results.data.data[region].zone
				allRegions[zone] = levelColors.plain;
			});
			setRegionColors(allRegions);
			if (monyr === 'daily') {
			 	longmonyr = setLongmonyr(results.data.data_thru);
			}
			setDatestr(longmonyr);
		})
		.catch(err => {
			console.log("Region Data Error: " + err);
			setRegionError(true);
		});
	}

	useEffect(() => {
		getPointData();
		getRegionData();
		setRegionError(false);
		 // eslint-disable-next-line
	}, [])

	return (
		<>
			{ kbdiOn &&
				<>
					{!regionError &&
						<RegionHeader
							title={"Keetch-Byram Drought Index (KBDI) Summary"}
							buttontext={"Table View"}
							addtext={addtext}
							buttonValue={buttonValue}
							handleButtonClick={props.handleButtonClick}
						/>
					}
					{markers &&
						<div className="mapandlegend-container">
							<MarkerMaps 
								selectedState={selectedState} 
								markers={markers} 
								regionColors={regionColors}
								mapTitle={datestr+" KBDI"}
								geo={monyr==="daily" ? geodata : (areaType === "region" ? "drought" : other_geodata)}
							/>
							<MapLegendKbdi
								title={"Point Values - KBDI Range"}
							/>
						</div>
					}
					{regionData &&
						<>
							<KbdiTable
								regionData={regionData}
								monyr={datestr}
								areaType={areaType}
							/>
						</>
					}
					{regionError &&
						<>
							<Error />
						</>
					}
				</>
			}
			{!kbdiOn &&
				<div style={{minHeight:"700px"}}>
					<RegionHeader
							title={"Keetch-Byram Drought Index (KBDI)"}
							addtext={"KBDI is only available for the months of April through November."}
					/>
				</div>
			}
	   </>
	);
}

export default KbdiRegion;
